'use client';

import { c as _c } from "react/compiler-runtime";
import OptimizedImage from '@/components/OptimizedImage';
import { RefObject, useRef, useState } from 'react';
import { useOnClickOutside } from 'usehooks-ts';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
type YoutubeCardDialogProps = {
  title: string;
  embedLink: string;
  description: string;
  thumbnail: string;
  isDragging: boolean;
};
function YoutubeCardDialog(t0) {
  const $ = _c(24);
  const {
    title,
    description,
    embedLink,
    thumbnail,
    isDragging
  } = t0;
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsOpen(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleClickOutside = t1;
  useOnClickOutside(ref as RefObject<HTMLElement>, handleClickOutside);
  const t2 = !isDragging;
  let t3;
  if ($[1] !== isDragging || $[2] !== t2) {
    t3 = cn("transition-all duration-300 group-hover:scale-110", {
      "pointer-events-none cursor-grabbing": isDragging,
      "pointer-events-auto cursor-pointer": t2
    });
    $[1] = isDragging;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3 || $[5] !== thumbnail) {
    t4 = <DialogTrigger asChild={true}><span className="group relative aspect-165/93 min-h-[236px] w-auto cursor-pointer overflow-hidden rounded-2xl"><OptimizedImage className={t3} src={thumbnail} alt="youtube-thumbnail" fill={true} sizes="(max-width: 480px) 100vw, 420px" /></span></DialogTrigger>;
    $[4] = t3;
    $[5] = thumbnail;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogTitle className="hidden" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== embedLink) {
    t6 = <DialogContent closeButtonClassName="size-8" className="grid h-screen max-w-(--breakpoint-3xl) flex-1 place-items-center bg-transparent">{t5}<iframe allowFullScreen={true} className="aspect-16/9 size-full max-h-[540px] max-w-[960px]" src={embedLink} /></DialogContent>;
    $[8] = embedLink;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isOpen || $[11] !== t4 || $[12] !== t6) {
    t7 = <div ref={ref} className="flex w-full flex-1"><Dialog onOpenChange={setIsOpen} open={isOpen}>{t4}{t6}</Dialog></div>;
    $[10] = isOpen;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== title) {
    t8 = <span className="subheader-2 1.5xl:subheader-1 w-full">{title}</span>;
    $[14] = title;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== description) {
    t9 = <span className="body 1.5xl:body-2 1.5xl:text-clip 1.5xl:whitespace-normal h-[inherit]">{description}</span>;
    $[16] = description;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="flex size-full flex-1 flex-col gap-2">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t7) {
    t11 = <div className="flex w-full max-w-[420px] min-w-[420px] flex-col gap-6">{t7}{t10}</div>;
    $[21] = t10;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}
export default YoutubeCardDialog;